import React from "react";
import { Skeleton } from 'primereact/skeleton';

const CompanyMobileSkeleton = () =>{
    return(
        <div className="container company-edit-container">
            <div className="flex justify-content-between px-4 py-3 col-12">
                <Skeleton shape="circle" size="25px" className='p-skeleton-circle'></Skeleton>
                <Skeleton shape="circle" size="25px" className='p-skeleton-circle'></Skeleton>
                <Skeleton shape="circle" size="25px" className='p-skeleton-circle'></Skeleton>
                <Skeleton shape="circle" size="25px" className='p-skeleton-circle'></Skeleton>
                <Skeleton shape="circle" size="25px" className='p-skeleton-circle'></Skeleton>
            </div>
            <div className="p-card pb-1">
                <div className="flex justify-content-between mt-1 mb-2 mr-2">
                    <Skeleton width="11rem"></Skeleton>
                    <Skeleton width="5rem"></Skeleton>
                </div>
                <div className="flex flex-column justify-content-between mb-2 mt-3">
                    <Skeleton shape="rectangle" height="25px" width="100%" className="mb-2 mr-2 mt-2" />
                    <Skeleton shape="rectangle" height="25px" width="100%" className="mb-2 mr-2 mt-2" />
                    <Skeleton shape="rectangle" height="25px" width="100%" className="mb-2 mr-2 mt-2" />
                    <Skeleton shape="rectangle" height="25px" width="100%" className="mb-2 mr-2 mt-2" />
               </div>
            </div>
            <div className="p-card pb-1">
                <div className="flex flex-column justify-content-between mb-2 mt-3">
                    <Skeleton shape="rectangle" height="25px" width="100%" className="mb-2 mr-2 mt-2" />
                    <Skeleton shape="rectangle" height="25px" width="100%" className="mb-2 mr-2 mt-2" />
                    <Skeleton shape="rectangle" height="25px" width="100%" className="mb-2 mr-2 mt-2" />
                    <Skeleton shape="rectangle" height="25px" width="100%" className="mb-2 mr-2 mt-2" />
               </div>
            </div>
            <div className="p-card pb-1">
                <div className="flex flex-column justify-content-between mb-2 mt-3">
                    <Skeleton shape="rectangle" height="25px" width="100%" className="mb-2 mr-2 mt-2" />
                    <Skeleton shape="rectangle" height="25px" width="100%" className="mb-2 mr-2 mt-2" />
                    <Skeleton shape="rectangle" height="25px" width="100%" className="mb-2 mr-2 mt-2" />
                    <Skeleton shape="rectangle" height="25px" width="100%" className="mb-2 mr-2 mt-2" />
               </div>
            </div>
        </div>
    )
}

export default CompanyMobileSkeleton;